<script>
export default {
  name: "MkIceCream",
  data() {
    return {
      iceCreams: [
        {
          name: "Чоколадо",
          priceS: "корнет 40 ден.",
          priceL: "мала чашка 50 ден.",
          priceXL: "голема чашка 70 ден."
        },
        {
          name: "Ванила",
          priceS: "корнет 40 ден.",
          priceL: "мала чашка 50 ден.",
          priceXL: "голема чашка 70 ден."
        },
        {
          name: "Јагода",
          priceS: "корнет 40 ден.",
          priceL: "мала чашка 50 ден.",
          priceXL: "голема чашка 70 ден."
        },
        {
          name: "Мешан",
          priceS: "корнет 40 ден.",
          priceL: "мала чашка 50 ден.",
          priceXL: "голема чашка 70 ден."
        },
      ],
    };
  },
}
</script>

<template>
<div class="main">
  <base-card v-for="iceCream in iceCreams" :key="iceCream.name">
    <v-card-title>{{ iceCream.name }}</v-card-title>
    <v-card-text>{{ iceCream.text }}</v-card-text>
    <v-card-actions class="flex text-right">
        <v-spacer></v-spacer>
        {{ iceCream.priceS }} <br />
        {{ iceCream.priceL }} <br />
        {{ iceCream.priceXL }}
    </v-card-actions>
  </base-card>
</div>
</template>

<style scoped>
.main {
  min-height: 100vh;
  background: transparent;
}
</style>